import { combineReducers } from 'redux'
import fullscreen from './fullscreen.reducer'
import modal from './modal.reducer'

export default combineReducers({
  fullscreen,
  modal
})
